/**
 * 一些默认的样式配置
 */
export var ACTIVE_TREND_STYLE = {
    isArea: true,
    lineStyle: {
        stroke: '#569CFF',
        lineWidth: 0.5,
    },
    areaStyle: {
        fill: '#3382F1',
        opacity: 0.07,
    },
};
export var DEFAULT_TREND_STYLE = {
    isArea: true,
    lineStyle: {
        stroke: '#B8C2D1',
        lineWidth: 0.5,
    },
    areaStyle: {
        fill: '#D8DFEA',
        opacity: 0.24,
    },
};
export var BACKGROUND_STYLE = {
    fill: '#416180',
    opacity: 0.05,
};
export var FOREGROUND_STYLE = {
    fill: '#3485F8',
    opacity: 0.06,
    stroke: '#4E83CD',
    strokeOpacity: 0.3,
    lineWidth: 0.8,
    brushRatio: 3 / 4,
};
export var SLIDER_BAR_LINE_GAP = 4;
export var SLIDER_BAR_HEIGHT = 6;
export var BAR_STYLE = {
    height: SLIDER_BAR_HEIGHT,
    fill: '#DEE6F2',
    highLightFill: '#CBDEF8',
    stroke: '#FFF',
    lineWidth: 1.2,
    cursor: 'move',
    radius: [2, 2, 0, 0],
};
export var DEFAULT_HANDLER_WIDTH = 6;
export var DEFAULT_HANDLER_HEIGHT = 12;
export var HANDLER_STYLE = {
    width: DEFAULT_HANDLER_WIDTH,
    height: DEFAULT_HANDLER_HEIGHT,
    fill: '#FFF',
    stroke: '#A6BDE1',
    radius: 2,
    opacity: 1,
    cursor: 'ew-resize',
    // 高亮的颜色
    highLightFill: '#3485F8',
    highLightStroke: '#3485F8',
};
export var TEXT_STYLE = {
    textBaseline: 'middle',
    fill: '#000',
    opacity: 0.45,
    padding: 2,
};
export var SLIDER_CHANGE = 'sliderchange';
export var MAX_TEXT_WIDTH = 60;
export var TEXT_SAFE_WIDTH = 4;
//# sourceMappingURL=constant.js.map